export const initialState = {
  protocol: 'https',
  valueShortLink: '',
  loadingShortLink: false,
  traffic: 'yourValues',
  linkPage: '',
  transliteration: false,
  userUtmLink: '',
  isErrorRequestShortLink: false,
  utmSource: {
    name: '',
    value: ''
  },
  utmMedium: {
    name: '',
    value: ''
  },
  utmCampaign: {
    name: '',
    value: ''
  },
  utmContent: {
    name: '',
    value: ''
  },
  utmTerm: {
    name: '',
    value: ''
  },
  getProtocolName: event => console.log(event),
  getLinkPage: event => console.log(event),
  getSourceTraffic: (event: Event) => console.log(event),
  getParameters: event => console.log(event),
  requestForShortLink: () => ({}),
  getTransliteration: () => ({}),
  sendAnalyticCopy: () => ({})
}
